import {
    GET_PAYMENT_DETAIL,
    GET_PAYMENT_DETAIL_SUCCESS,
    GET_PAYMENT_DETAIL_FAIL,

} from "./actionTypes"

export const getPaymentDetail = filter => ({
    type: GET_PAYMENT_DETAIL,
    payload: filter,
})

export const getPaymentDetailsSuccess = paymentDetails =>
({
    type: GET_PAYMENT_DETAIL_SUCCESS,
    payload: paymentDetails,
})


export const getPaymentDetailsFail = error => ({
    type: GET_PAYMENT_DETAIL_FAIL,
    payload: error,
})